export const SENTRY_DSN = import.meta.env.VITE_APP_SENTRY_DSN;
